// source: compliance_report.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
var task_pb = require('./task_pb.js');
goog.object.extend(proto, task_pb);
var cost_analysis_pb = require('./cost_analysis_pb.js');
goog.object.extend(proto, cost_analysis_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.compliance.ComplianceReportStep', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccBookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
iccSectionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 5, ""),
forceRecompute: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest;
  return proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccSectionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceRecompute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIccSectionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getForceRecompute();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string icc_book_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icc_section_id = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.getIccSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.setIccSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string file_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool force_recompute = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.getForceRecompute = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskRequest.prototype.setForceRecompute = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, ""),
estimatedDurationSeconds: jspb.Message.getFieldWithDefault(msg, 4, 0),
costAnalysis: (f = msg.getCostAnalysis()) && cost_analysis_pb.MetaCostAnalysis.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse;
  return proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDurationSeconds(value);
      break;
    case 5:
      var value = new cost_analysis_pb.MetaCostAnalysis;
      reader.readMessage(value,cost_analysis_pb.MetaCostAnalysis.deserializeBinaryFromReader);
      msg.setCostAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEstimatedDurationSeconds();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCostAnalysis();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      cost_analysis_pb.MetaCostAnalysis.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 estimated_duration_seconds = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.getEstimatedDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.setEstimatedDurationSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis cost_analysis = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.getCostAnalysis = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis} */ (
    jspb.Message.getWrapperField(this, cost_analysis_pb.MetaCostAnalysis, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.cost.MetaCostAnalysis|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.setCostAnalysis = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.clearCostAnalysis = function() {
  return this.setCostAnalysis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.StartPageSectionComplianceReportTaskResponse.prototype.hasCostAnalysis = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.service.compliance.ComplianceReportStep = {
  UNKNOWN_STEP: 0,
  SERVER_WARMUP: 1,
  INITIALIZE_COMPLIANCE_ANALYSIS: 2,
  LOAD_PROJECT_AND_SECTION_DATA: 3,
  EXTRACT_PAGE_CONTENT: 4,
  ANALYZE_SECTION_REQUIREMENTS: 5,
  EVALUATE_COMPLIANCE_STATUS: 6,
  GENERATE_COMPLIANCE_STATEMENT: 7,
  SAVE_COMPLIANCE_REPORT: 8,
  REPORT_GENERATION_COMPLETE: 9
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service.compliance);
